//import './App.css';
import AppMain from './components/AppMain';
import GlobalStyle from './style/theme/GlobalStyle';
import { ThemeProvider } from 'styled-components';
import theme from './style/theme/theme';
import ErrorBoundary from './components/common/ErrorBoundary';
import { IndexedDBContext } from './context/indexedDBContext';
import { usePageViewToGASender } from './hooks/gaHook';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { USE_REACT_ROUTER } from './define/global';
import { isDevMode, isProductionMode } from './utils/util';
import ErrorPage from './components/router/ErrorPage';
import ProductTypeRouter from './components/router/ProductTypeRouter';
import ErrorPageWithRouter from './components/router/ErrorPageWithRouter';
import { useHttpsAutoRedirector } from './hooks/httpsAutoRedirectorHook';
import { POWebofficeSDKProvider } from './context/poWebOfficeSDKContext';

function App() {
  // convert Http to Https in production mode
  useHttpsAutoRedirector({
    conditionFn: isProductionMode
  });

  //GA pageView
  usePageViewToGASender();

  return (
    <>
      <ErrorBoundary>
        <GlobalStyle></GlobalStyle>
        <ThemeProvider theme={theme}>
          <IndexedDBContext>
            <POWebofficeSDKProvider>
              {USE_REACT_ROUTER ? (
                <BrowserRouter>
                  <Switch>
                    <Route exact path="/">
                      {isDevMode() ? (
                        <Redirect to="/dev/hwp" />
                      ) : (
                        <Redirect to="/whale-space/hwp" />
                      )}
                    </Route>
                    <Route path="/error" component={ErrorPageWithRouter}></Route>
                    <Route path="/:productType" component={ProductTypeRouter}></Route>
                    <Route component={ErrorPage} />
                  </Switch>
                </BrowserRouter>
              ) : (
                <AppMain />
              )}
            </POWebofficeSDKProvider>
          </IndexedDBContext>
        </ThemeProvider>
      </ErrorBoundary>
    </>
  );
}

export default App;
